import { useMemo } from "react";
import { ArgumentNotSuppliedError } from "client_legacy/ndaw/errors";
import { getEnvironmentName } from "client_legacy/ndaw/navigator";
import { userConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export function useUserScopedKey(key: string): string {
	if (!key) {
		throw new ArgumentNotSuppliedError("key");
	}

	const result: string = useMemo(
		() => getUserScopedKey(userConfiguration().currentUserIdentity.userId, key),
		[key]
	);

	return result;
}

export function getUserScopedKey(userId: number, key: string): string {
	return `${getEnvironmentName()}:${userId}:${key}`;
}
